import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../utils/breadCrumbs";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  ContainerBB,
  TitleBB,
  TitleJunction,
  ButtonRemove,
  FormSection,
  SectionLabel,
  HelpText,
  LocationsContainer,
  LocationPanel,
  PanelHeader,
  ItemCount,
  SearchBox,
  DebouncedInput,
  LocationList,
  TransferButtons,
  TransferButton,
} from "./expeditionProcessDetail.styled";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import moment from "moment-timezone";
import { PROCESS_EXPEDITION_OPEN, VARIETIES } from "../../../../constants";

const ExpeditionProcessDetailView = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, finish, onSave, exportToExcel, onDelete } = props;

  let sumIn = 0;

  if (data) {
    if (data.expeditionItemsProcess && data.expeditionItemsProcess.length > 0) {
      sumIn = data.expeditionItemsProcess.length;
      // for (const dataIn of data.inventarys) {
      //   sumIn += dataIn.weight;
      // }
    }
  }

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.expeditionProcess.title"), path: PATHS.EXPEDITION_LIST },
    { label: t("forms.expeditionDetail.title") },
  ];

  const renderBB = (bbs, isInput = true) => {
    if (bbs && bbs.length > 0) {
      return bbs.map((bb) => {
        return (
          <div className="row mb-1" key={bb.batch}>
            <div className="col-3">{bb.batch}</div>
            <div className="col-3">{`(${bb.numArticle})`}</div>
            <div className="col-2 ">{`${bb.weight}Kg`}</div>
            <div className="col-3 ">{moment(bb.date).format("DD-MM-yyyy")}</div>
            {data.status === PROCESS_EXPEDITION_OPEN.code && (
              <div className="col-1">
                <ButtonRemove onClick={() => onDelete(bb.batch)}>
                  <i className="fa-solid fa-trash-can "></i>
                </ButtonRemove>
              </div>
            )}

            {/* <div className="col-2 text-end">
              {isInput && (
                <ButtonRemove type="button" onClick={() => removeItem(bb)}>
                  <i className="fa-solid fa-trash-can"></i>
                </ButtonRemove>
              )}
            </div> */}
          </div>
        );
      });
    } else {
      return (
        <div className="row">
          <div className="col-12 text-center">{t("forms.inventary.noBb")}</div>
        </div>
      );
    }
  };
  return (
    <>
      {data && (
        <>
          <div className="row justify-content-center">
            <div className="col-6 border p-5">
              <TitleJunction className="col-12 col-md-11 ">
                <div className="d-flex">
                  {`${
                    data?.status === PROCESS_EXPEDITION_OPEN.code
                      ? t("forms.expeditionDetail.processOpen")
                      : t("forms.expeditionDetail.processClosed")
                  } (${getDateFormatTimeZone(data.dateInit, "DD-MM-yyyy")})
                `}
                </div>
              </TitleJunction>
              <div className="col-12 mt-3">
                <div className="row g-3">
                  <div className="col-12">
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.article")}:</strong>{" "}
                      {data.article}
                    </div>
                    {/* <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.code")}:</strong>{" "}
                      {data.code}
                    </div> */}
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.batchOut")}:</strong>{" "}
                      {data.batchOut}
                    </div>
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.type")}:</strong>{" "}
                      {data.type}
                    </div>
                    {/* </div>
                  <div className="col-12 col-md-6"> */}
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.origen")}:</strong>{" "}
                      {data.origen}
                    </div>
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.propietary")}:</strong>{" "}
                      {data.propietary}
                    </div>
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.priority")}:</strong>{" "}
                      {data.priority}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6 ">
              <div className="text-end mb-3">
                <button
                  type="button"
                  className="btn btn-md btn-secondary"
                  onClick={() => finish()}
                >
                  {t("forms.expeditionDetail.buttons.finish")}
                </button>
              </div>
              <div className="row">
                <TitleBB className="col-12 d-flex justify-content-between">
                  <div>{t("forms.expeditionDetail.bbIn")}</div>
                  <div>{`Total: ${sumIn} BB`}</div>
                </TitleBB>
              </div>
              <div className="row">
                <div className="col-12 ">
                  <ContainerBB>
                    {renderBB(data.expeditionItemsProcess)}
                  </ContainerBB>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex col-12 col-md-11 mt-3 mb-3 gap-2">
            {/* {data.status === "OPEN" && (
                <>
                  <button
                    type="button"
                    className="btn btn-mg btn-secondary"
                    onClick={onSave}
                  >
                    {t("forms.inventary.buttons.save")}
                  </button>
                </>
              )} */}

            {/* {data.status === "OPEN" && (
              <>
                
                <button
                  type="button"
                  className="btn btn-md btn-primary"
                  onClick={() => onSave()}
                >
                  {t("forms.expeditionDetail.buttons.addBB")}
                </button>
              </>
            )} */}
          </div>
        </>
      )}
    </>
  );
};

ExpeditionProcessDetailView.propTypes = {
  // handleSubmit: PropTypes.func,
  // initialValues: PropTypes.object,
};

export default ExpeditionProcessDetailView;
